/* eslint-disable import/prefer-default-export */
import { FC, StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import { IntlProvider } from 'react-intl';
import { Provider, useSelector } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import Direction from './enums/Direction';
import loadLanguage from './helpers/loadLanguage';
import App from './App';
import Store from './redux/Store';
import { getActiveLanguage, getIsRTL } from './redux/LanguageSlice/LanguageSelectors';
import queryClient from './query/client';

import 'core-js/stable';
import './stylesheets/styles.scss';
import 'font-awesome/css/font-awesome.css';

const Host: FC = () => {
	const [messages, setMessages] = useState();
	const language = useSelector(getActiveLanguage);
	const isRTL = useSelector(getIsRTL);

	useEffect(() => {
		loadLanguage(language).then(setMessages);
	}, [language]);

	useEffect(() => {
		document.body.dir = isRTL ? Direction.RTL : Direction.LTR;
	}, [isRTL]);

	if (!messages) return null;

	return (
		<IntlProvider locale={language} messages={messages}>
			<App />
		</IntlProvider>
	);
};

Modal.setAppElement('#root');
const root = createRoot(document.getElementById('root')!);
root.render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<Provider store={Store}>
				<Host />
			</Provider>
		</QueryClientProvider>
	</StrictMode>
);
